import { render, staticRenderFns } from "./HistoryDetailComponent.vue?vue&type=template&id=25900da0&scoped=true&"
import script from "./HistoryDetailComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25900da0",
  null
  
)

export default component.exports